import { useState } from 'react';
import './WorkerService.less'
import { RightArrow2Outlined } from 'dd-icons';
import useHistory from '@/hooks/useHistory'
import { Modal, Toast } from 'dingtalk-design-mobile';
import copy from 'copy-to-clipboard'
import { setCommand } from "@/utils/jsapi-auth";
import userIdMap from "@/const"

const WorkerService = () => {

  const history = useHistory()

  const [list, setList] = useState([
    {name: '住院暖心慰问', img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-02.png', url: '', page: 'Hospital'},
    {name: '医疗互助慰问', img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-03.png', url: '', page: 'Medical'},
    {name: '工伤探视慰问', img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-04.png', url: '', page: 'Injury'},
    {name: '意外伤害慰问', img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-05.png', url: '', page: 'Accidental'},
  ])

  const toPage = (val) => {
    history.push('/ApplicationIssues?page=' + val)
  }
  const handleDownload = () => {
    Modal.alert('', '请用手机浏览器打开链接下载资料', [
      {text: '取消', onClick: () => {}},
      {text: '复制链接', onClick: () => {
        Toast.success({
          content: '复制成功',
          duration: 2
        })
        copy('https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/2.%E4%BA%92%E5%8A%A9%E4%BF%9D%E9%9A%9C%EF%BC%88%E4%BA%8C%E6%AC%A1%E5%8C%BB%E4%BF%9D%EF%BC%89.zip')
      }}
    ])
  }
  const toDetail = (val) => {
    history.push('/WorkerServiceDetail?id=' + val)
  }

  const toCulturePalaceDetail = (id) => {
    history.push('/CulturePalaceDetail?id=' + id)
  }

  const handleChat = () => {
    setCommand('openChatByUserId', {
      userId: userIdMap['wqj']
    })
  }

  return (
    <div className="pg-worker-service">
      <div className='title'>职工活动</div>
      <div className='card'>
        <img onClick={() => toCulturePalaceDetail('01')} className='img img1' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/worker01.png' />
        <img onClick={() => toCulturePalaceDetail('02')} className='img img2' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/worker02.png' />
      </div>
      <div className='title'>职工互助保障</div>
      <div className='card'>
        <div className='row'>
          <div className='row-left'>
            <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-01.png' />
            互助保障
          </div>
          <div className='row-right' onClick={handleDownload}>下载模板</div>
        </div>
        <div className='card-footer' onClick={handleChat}>联系审核人员<RightArrow2Outlined className='arrow-icon' /></div>
      </div>
      <div className='title'>帮扶救助</div>
      <div className='card'>
        <div className='row'>
          <div className='row-left'>
            <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/worker/icon-05.png' />
            医疗救助
          </div>
          <div className='row-right' onClick={() => toPage('Bailout')}>我要申请</div>
        </div>
        <div className='card-footer--wrap'>
          <div className='card-footer footer-item1' onClick={() => toDetail(2)}>查看政策文件<RightArrow2Outlined className='arrow-icon' /></div>
          <div className='card-footer' onClick={handleChat}>联系审核人员<RightArrow2Outlined className='arrow-icon' /></div>
        </div>
      </div>
      <div className='title'>关爱互助慰问</div>
      <div className='card card1'>
        {
          list.map((item, index) => {
            return (
              <div className='row' key={index}>
                <div className='row-left'>
                  <img className='icon' src={ item.img } />
                  { item.name }
                </div>
                <div className='row-right' onClick={() => toPage(item.page)}>我要申请</div>
              </div>
            )
          })
        }
        <div className='card-footer--wrap'>
          <div className='card-footer footer-item1' onClick={() => toDetail(1)}>查看政策文件<RightArrow2Outlined className='arrow-icon' /></div>
          <div className='card-footer' onClick={handleChat}>联系审核人员<RightArrow2Outlined className='arrow-icon' /></div>
        </div>
      </div>
    </div>
  )
}

export default WorkerService